// extracted by mini-css-extract-plugin
export default {"milestoneEdit":"milestone-edit_page_milestoneEdit__mtphi"};